import { getIntDate } from '@/views/analysis/common.js'
export default {
  titleTxt: [
    {
      title: '指标总览',
      tipTxt: '以列表形式，显示各品牌指标数据情况，方便对比点击右侧详情，进入具体品牌的数据看板。'
    },
    {
      title: '指标趋势',
      tipTxt: '显示各品牌的指标波动趋势。'
    },
    {
      title: '达人贡献对比分析',
      tipTxt: '显示各品牌中各类达人的指标贡献占比情况，例如，各个品牌中，分别是哪类达人的互动量占比最大。'
    },
    {
      title: '达人贡献对比分析',
      tipTxt: '显示各品牌中各类笔记的指标贡献占比情况，例如，各个品牌中，分别是哪种类型笔记的互动量占比最大。'
    }
  ],
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brandList',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/line/label',
      method: 'get',
      flagKey: 'lineName',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/is/prereport/label',
      method: 'get',
      flagKey: 'isPrereport',
      id: 'name',
      name: 'name'
    }
  ],
  filterForm: [
    {
      type: 'select',
      id: 'brandList',
      label: '品牌',
      multiple: true,
      collapseTags: true,
      width: '250px',
      placeholder: '全部',
      intValue: [],
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'platform',
      label: '平台',
      width: '200px',
      intintValue: '',
      children: []
    }, {
      type: 'select',
      id: 'lineName',
      label: '产线',
      clearable: true,
      placeholder: '综合',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'isPrereport',
      label: '是否报备',
      placeholder: '全部',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'tab',
      id: 'timeType',
      label: '选择时间',
      intValue: '0',
      children: [{
        id: '0',
        name: '月报',
        showItemId: 'dateMonth',
        hideItemId: 'dateTime'
      }, {
        id: '1',
        name: '日报',
        showItemId: 'dateTime',
        hideItemId: 'dateMonth'
      }]
    }, {
      type: 'month',
      isHide: false,
      format: 'yyyy年 MM月',
      valueFormat: 'yyyy-MM',
      clearable: true,
      id: 'dateMonth',
      label: '',
      width: '160px',
      // intValue: '2022-02'
      intValue: getIntDate()
    }, {
      type: 'datesRange',
      dateType: 'date',
      isHide: true,
      clearable: true,
      id: 'dateTime',
      startTimeId: 'dateTimeStartTime',
      endTimeId: 'dateTimeEndTime',
      label: '',
      width: '400px',
      intValue: ['', '']
    }
  ],
  formRules: {},
  // 声量趋势
  volumnFormArr: [
    {
      type: 'radio',
      id: 'selectType',
      label: '指标',
      width: '100%',
      intValue: '1',
      children: [
        {
          id: '1',
          name: '内容数'
        }, {
          id: '7',
          name: '创作人数'
        }, {
          id: '2',
          name: '互动量'
        }, {
          id: '8',
          name: '平均互动量'
        }, {
          id: '3',
          name: '品牌搜索指数'
        }, {
          id: '4',
          name: '爆款率'
        }
      ]
    }
  ],
  sortRules: [
    {
      name: '降序',
      id: '1'
    }, {
      name: '升序',
      id: '2'
    }
  ],
  // 产线分析数据 - 表头
  tableHead: [
    {
      label: '序号',
      key: '$index',
      width: '80',
      fixed: true
    }, {
      label: '品牌',
      key: 'brandHtml',
      width: 200,
      isHtml: true,
      fixed: true
    }, {
      label: '产线',
      key: 'lineName',
      fixed: true
    }, {
      label: '内容数',
      key: 'contentCnt'
    }, {
      label: '创作人数',
      key: 'creatorCnt'
    }, {
      label: '互动量',
      key: 'interactNumSum',
      txtAlign: 'right'
    }, {
      label: '平均互动量',
      key: 'interactNumAvg'
    }, {
      label: '品牌搜索指数',
      key: 'searchIndex'
    }, {
      label: '爆款率',
      key: 'popularRatio'
    }
    // , {
    //   label: '评论数',
    //   key: 'commentCnt'
    // }
  ],
  tableBtn: [
    {
      id: 'check',
      name: '查看详情',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    }
  ],
  contributeSorts: [
    {
      name: '互动量',
      id: '1'
    }
  ],
  barLabelAjaxList: [
    {
      url: '/api/label/auth/level/label',
      method: 'get',
      param: {},
      flagKey: 'authLevel',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/follower/level/label',
      method: 'get',
      param: {},
      flagKey: 'followerLevel',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/content/type/label',
      method: 'get',
      param: {},
      flagKey: 'contentType',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/theme/label',
      method: 'get',
      param: {},
      flagKey: 'theme',
      id: 'name',
      name: 'name'
    }
  ],
  columnList: [
    {
      id: 'contribute',
      name: '达人贡献对比分析',
      tipTxt: '显示各品牌中各类达人的指标贡献占比情况，例如，各个品牌中，分别是哪类达人的互动量占比最大。',
      selectKey: 'contributeSortIndex',
      flagKeys: ['authLevel', 'followerLevel'],
      charts: [
        {
          name: '达人类型',
          tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容类型的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容类型包括：测评、好物推荐、选购、横评、使用体验等。',
          id: 'type-column-chart',
          flagKey: 'authLevel',
          type: 1,
          isLoading: false,
          isNodata: false
        }, {
          name: '粉丝量级',
          tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容场景的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容场景包括：门店、真实用户、伪真实用户、素材剪辑',
          id: 'fens-column-chart',
          type: 2,
          flagKey: 'followerLevel',
          isLoading: false,
          isNodata: false
        }
      ]
    }, {
      id: 'content',
      name: '内容维度对比分析',
      tipTxt: '显示各品牌中各类笔记的指标贡献占比情况，例如，各个品牌中，分别是哪种类型笔记的互动量占比最大。',
      selectKey: 'contentSortIndex',
      flagKeys: ['contentType', 'theme'],
      charts: [
        {
          name: '内容类型',
          tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容选题的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容选题包括：双方共创、达人原创、品牌方规定、平台热点等。',
          id: 'content-type-column-chart',
          type: 3,
          flagKey: 'contentType',
          isLoading: false,
          isNodata: false
        }, {
          name: '内容选题',
          tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容封面类型的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容封面包括：门店、厨房、房间、客厅、人物、美食、产品、花字等。',
          id: 'content-choose-column-chart',
          type: 4,
          flagKey: 'theme',
          isLoading: false,
          isNodata: false
        }
      ]
    }
  ]
}
